import { Button, Form, Input, Select, Switch } from "antd"
import PageContentWrapper from "../../components/PageContentWrapper"
import { useEffect, useState } from "react"
import { getConfiguration, updateConfiguration } from "../../appRedux/actions/Configuration"
import { useDispatch, useSelector } from "react-redux"
import { getParticipants, getUsers, reset2FA, set2FAAdmin } from "../../appRedux/actions"
import { CheckCircleOutlined, CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons"

export default function TwoFA() {
  const [form] = Form.useForm()
  const [userId, setUserId] = useState(null)
  const [users, setUsers] = useState([])
  const [searchUsers, setSearchUsers] = useState("");

  // useEffect(() => {
  //   getConfiguration("twofa_enabled")
  //     .then(data => {
  //       form.setFieldsValue({
  //         twofa_enabled: data.value.toLowerCase() == "true" ? true : false
  //       })
  //     })
  // }, [])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getUsers({ search: searchUsers }).then(data => setUsers(data))
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [searchUsers]);

  function resetUserSecret() {
    if (userId)
      reset2FA(userId)
  }

  function set2FAUser(enabled) {
    if (userId)
      set2FAAdmin(userId, enabled)
  }

  return <>
    <PageContentWrapper title="Autentikasi Dua Faktor (2FA)" backLink={"/configurations"}>
      <Form
        form={form}
        layout="vertical"
        // initialValues={{
        //   twofa_enabled: false,
        // }}
        style={{ padding: 10 }}
      // onFinish={() => { }}
      // onValuesChange={(changedValues) => {
      //   for (const [key, value] of Object.entries(changedValues)) {
      //     updateConfiguration({
      //       name: key,
      //       value: value
      //     })
      //   }
      // }}
      >
        {/* <Form.Item
          name="twofa_enabled"
          label="2FA Aktif?"
          valuePropName="checked"
        >
          <Switch checkedChildren="Ya" unCheckedChildren="Tidak" />
        </Form.Item> */}
        <Form.Item
          label="Reset 2FA User Secret"
        >
          <Select
            showSearch
            onSearch={setSearchUsers}
            filterOption={false}
            notFoundContent={null}
            style={{
              width: 'calc(100% - 200px)',
            }}
            onChange={setUserId}
          >
            {users.map((p) => (
              <Select.Option key={p.id} value={p.id}>
                {p.name} {`(${p.email})`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
        >
          <Input.Group compact={false}>
            <Button type="primary" disabled={!userId} onClick={resetUserSecret}><ReloadOutlined /> Reset Secret</Button>
            <Button type="primary" disabled={!userId} onClick={() => set2FAUser(true)}><CheckCircleOutlined /> Set On</Button>
            <Button type="primary" disabled={!userId} onClick={() => set2FAUser(false)}><CloseCircleOutlined /> Set Off</Button>
          </Input.Group>
        </Form.Item>
      </Form>
    </PageContentWrapper >
  </>
}